import { AxiosApi } from './axiosApi'

import { configureAuthenticatedAPIBO } from '../configuration/authenticatedBO'

class AuthenticatedAPIBO extends AxiosApi {
  constructor({
    domain,
    apiKey,
    useInterceptors = true
  }: {
    domain: string
    apiKey?: string
    useInterceptors?: boolean
  }) {
    super(configureAuthenticatedAPIBO(domain, apiKey, useInterceptors))
  }
}

export { AuthenticatedAPIBO }
